const en = {
  updateSuccess: 'Update successful',
  updateFailed: 'Update failed',
  delOrgSuccess: 'Organization deleted successfully, switching to the next organization for you.',
  delOrgFailed: 'Organization deleted failed',
  addSuccess: 'Added successfully',
  addFailed: 'Added failed',
  authSetSuccess: 'Permissions set successfully, please refresh the page to view.',
  authSetFailed: 'Permissions set failed',
  disblMemSuccess: 'Disabled member successfully',
  disblMemFailed: 'Disabled member failed',
  viewOrgRepo: 'Organization warehouse view',
  fullPermissions: 'All permissions',
  editOrgDetails: 'Organization details edit',
  manageSubOrgs: 'Subordinate organization management',
  manageOrgMems: 'Organization member management',
  manageOrgDetailsMems: 'Organization details and member management',
  orgRepoInbound: 'Organization warehouse (inbound)',
  orgRepoOut: 'Organization warehouse (outbound)',
  manageSubOrgRepos: 'Subordinate organization warehouse management (inbound and outbound)',
  manageSubOrgAndMeb:'Subordinate organizations and member management',
  mobileNumber: 'Mobile number',
  purview: 'Permissions',
  avatar: 'Avatar',
  phNumber: 'Phone number',
  setPermissions: 'Permission settings',
  disable: 'Disable',
  enable: 'Enable',
  thisMember:'this member',
  delOrgTip1: 'Are you sure to delete this organization?',
  delOrgTip2: 'After deleting the organization, the organization information cannot be restored, and the users under the organization will also be removed. Are you sure about the deletion?',
  createNewMem: 'Create new member',
  selPerson: 'Please select personnel',
  orgInfo: 'Organization details',
  addOrg: 'Add organization',
  addSubOrgBut: 'Add subordinate organization',
  members: 'Members',
  noMem: 'No members',
  name: 'Name',
  orgNameRequired: 'Organization name cannot be empty!',
  desc: 'Describe',
  cancel: 'Cancel',
  memList: 'Member list',
  addOrgMem: 'Add members',
  selMem: 'Please select member',
  setMemPurview: 'Set member ({{userName}}) permissions',
  memDetails: 'Member details',
  prompt: 'Tips',
  conAction: 'Are you sure you want',
  enterName: 'Please enter a name',
  enterDesc: 'Please enter a description',
  managOrgUser: 'System management/system manager, manager org|user',
  editOrgBasicInfo: 'Organization basic information modification',
  manageOrgUsers: 'Organization user management',
  manageOrgProfile: 'Organization profile management',
  inboundManag: 'Inbound management',
  outboundManag: 'Outbound management',
  manageSubInv: 'Subordinate inventory management',
  unPurview:'Unknown permissions',
  plEnterOrgName: 'Please enter the organization name',
  addOrgStru: 'Add organizational structure',
  noMove: 'Prohibit movement at the same level',
  addSubOrg: 'Add a subordinate organization of ({{name}})', 
  noData: 'No data',
  delOrgTip3: "This organization has subordinate organizations. Please delete the subordinate organizations first and then delete them again.",
  orgMoveSuc: "Successfully organized the movement",
  orgMoveFail: "Organizational movement failed",
  selectAll: "All",
  userNoOrg: "The user is not participating in the organization and will log out after 5 seconds.",
  cancelTip: "The personnel have already been selected. Are you sure to cancel?",
  delOrg: "Delete organization",
  plEnterUserName: "Please enter Name1, Name2, and phone number to search",
  noOrgData: "No data found for this organization/organization may be deleted",
  orgFetchFail: 'Failed to obtain organizational information',
  orgListEmpty: "There are currently no organizations available. Please add an organization first.",
  selectOrg: "Please select an organization first",
  orgDisabled: "The organization has been disabled or does not exist",
  modifyOrgInfo: "Modifying organizational information",
  addOrDisableOrgMember: "Add or disable an organization member",
  orgMemberPermissions: "Set organization member permissions"
};

export default en;